enum RouteSectionsPrefixes {
  COMPANY_DATABASE__CONTRACTORS = "company_database__contractors",
  PROJECT_ALL_VISITS = "clients_visits_all_visits",
  COMPANY_DATABASE__REQUESTS = "company_database__requests",
  MY_FAVORITES = "my_favorites",
  TALENT_MAPPING = "talent-mapping",
  MARKETPLACE = "marketplace",
  PROJECTS = "projects",
  PROJECTS_RESOURCE = "projects_contractors",
  REQUESTS = "requests",
  GROUPS = "groups",
  POSTINGS = "postings",
  MANAGERS = "managers",
  ALL_DOCUMENTS = "all_documents",
  PROFILE_SETTINGS = "Settings",
  PROJECTS_DOCUMENTS = "projects_documents",
  CONTRACTORS_DOCUMENTS = "contractors_documents",
  MANAGERS_DOCUMENTS = "managers_documents",
  MY_DATABASE = "my_database",
  INBOX = "inbox",
  POSTINGS_INTERNAL = "postings_internal",
  POSTINGS_MARKETPLACE = "postings_marketplace",
  APPLICATIONS = "applications",
  COMPANY = "company",
  TIMESHEET =  "timesheet",
}

export default RouteSectionsPrefixes;
